import leftArrow from '../assets/leftArrow.svg';

export const size = {
  mobileS: 320,
  mobileM: 375,
  mobileL: 425,
  mobileXL: 600,
  tablet: 768,
  laptopS: 800,
  laptopMS: 906,
  laptop: 1024,
  laptopM: 1050,
  laptopL: 1440,
  desktop: 2560,
};

export const sizeInPX = new Proxy(size, {
  get: function (target: any, prop) {
    return target[prop] + 'px';
  },
});

const onlineTheme = {
  font: {
    family: 'Roboto',
    size: {
      small: '13px',
      smallMedium: '16px',
      smallMedium2: '18px',
      smallMedium2Plus1: '19px',
      smallMedium3: '20px',
      medium: '22px',
      medium2: '24px',
      medium3: '26px',
      mediumLarge: '30px',
      large: '36px',
      huge: '42px',
      huger: '48px',
      gargantuan: '100px',
    },
    weight: {
      lighterEx: 100,
      lighter: 200,
      light: 300,
      normal: 400,
      medium: 500,
      bold: 600,
    },
  },
  colors: {
    white: '#fff',
    whiteGray: '#f4f4f4',
    black: '#000',
    light: '#38c5f3',
    light2: '#41c6f2',
    light3: '#00a7e1',
    light4: '#04a6e1',
    dark: '#345275',
    border: '#e0e0e0',
    seperator: '#c0c0c0',
    grayBlueish: '#77888c',
    gray: '#9e9e9e',
    grayLight: '#f7f7f7',
    grayLight2: '#829099',
    grayDark: 'rgb(74,74,74)',
    primary: '#002169',
    primaryDark: '#345374',
    primaryDark2: '#212d65',
    primaryLightBlue: '#3156FF',
    heroBackground: '#FCFCFC',
    darkOpac: 'rgba(52,82,117, 0.6)',
    error: '#f56161',
    disabledButton: '#d8d8d8',
    inputBackground: 'rgba(54, 54, 54, 0.05)',
    placeholder: '#6d6e71',
    sunbitYellow: '#ffc80a',
    headlineGrey: '#8597ad',
    headlineGrey2: '#7897ab',
    headlineGrey3: '#9da6ac',
    homeBackground: '#f3f9ff',
    lightBlue: '#03a5df',
    brightBlue95: '#F5F7FF',
    autocompleteSuggestion: '#8090B4',
    autocompleteSuggestionMatched: '#002169',
    mediumGray: '#8F97A8',
    primaryBackground: '#38c5f3',
  },
  desktop: {
    width: 1330,
    height: 780,
  },
  pos: {
    width: 768,
    height: 1024,
  },
  spacing: {
    small: 5,
    smallMedium: 7,
    medium: 10,
    mediumLarger: 15,
    large: 20,
    large2: 25,
    larger: 30,
    larger2: 40,
    huge: 60,
    hugeHuger: 75,
    huger: 90,
    gargantuan: 120,
    mobile: 27,
  },
  device: {
    mobileS: `(min-width: ${sizeInPX.mobileS})`,
    mobileM: `(min-width: ${sizeInPX.mobileM})`,
    mobileL: `(min-width: ${sizeInPX.mobileL})`,
    tablet: `(min-width: ${sizeInPX.tablet})`,
    laptopS: `(min-width: ${sizeInPX.laptopS})`,
    laptop: `(min-width: ${sizeInPX.laptop})`,
    laptopL: `(min-width: ${sizeInPX.laptopL})`,
    desktop: `(min-width: ${sizeInPX.desktop})`,
    desktopL: `(min-width: ${sizeInPX.desktop})`,
    max: {
      mobileS: `(max-width: ${sizeInPX.mobileS})`,
      mobileM: `(max-width: ${sizeInPX.mobileM})`,
      mobileL: `(max-width: ${sizeInPX.mobileL})`,
      mobileXL: `(max-width: ${sizeInPX.mobileXL})`,
      tablet: `(max-width: ${sizeInPX.tablet})`,
      laptopS: `(max-width: ${sizeInPX.laptopS})`,
      laptopMS: `(max-width: ${sizeInPX.laptopMS})`,
      laptop: `(max-width: ${sizeInPX.laptop})`,
      laptopL: `(max-width: ${sizeInPX.laptopL})`,
      desktop: `(max-width: ${sizeInPX.desktop})`,
      desktopL: `(max-width: ${sizeInPX.desktop})`,
    },
  },
  borderRadiusCommon: 5,
  borderRadiusRound: 2000,
  icons: {
    leftArrow,
    sizes: {
      iconSizeMicro: '6',
      iconSizeTiny: '10',
      iconSizeSmall: '20',
      iconSizeNormal: '24',
      iconSizeMedium: '40',
      iconSizeLarge: '50',
    },
    symbols: {
      materialIconArrowForward: 'arrow_forward',
      materialIconStore: 'store',
      materialIconApply: 'touch_app',
      materialIconShieldConfirm: 'verified_user',
      materialIconCircleFull: 'lens',
    },
  },
};

export interface ITheme {
  theme: OnlineThemeType;
}

export default onlineTheme;
export type OnlineThemeType = typeof onlineTheme;

export type ThemeColors = keyof OnlineThemeType['colors'];
